import { browserRum } from './rum'

export const observabilityUtils = {
  browserRum,
}
